<div class="container-fluid">
  <div class="my-2">
    <button
      *ngIf="canAdd"
      (click)="addNewRow()"
      mat-stroked-button
      color="primary"
    >
      <mat-icon>add</mat-icon>
      {{ "ADD_ROLE_APP.BUTTONS.ADD" | translate }}
    </button>
  </div>

  <div class="table-container compact-inputs">
    <div class="table-responsive">
      <table class="table table-bordered table-hover">
        <thead>
          <tr>
            <th *ngFor="let key of activeColumns">
              {{ getColumnLabel(key) | titlecase }}
            </th>
            <th>{{ "ADD_ROLE_APP.TABLE.ACTIONS" | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <!-- New Row -->
          <tr *ngIf="isAddingNewRow">
            <td *ngFor="let key of activeColumns">
              <!-- Select Dropdown -->
              <ng-container *ngIf="getDataType(key, newRow[key]) === 'select'">
                <mat-form-field
                  appearance="outline"
                  class="w-100 dropdown-pd-none"
                >
                  <mat-select
                    [(value)]="newRow[key]"
                    (selectionChange)="handleChange(key)"
                    [disabled]="isNonEditable(key)"
                  >
                    <mat-option
                      *ngFor="let option of dropdownOptions[key]"
                      [value]="option?.value || option"
                    >
                      {{ option?.name || option?.title || option }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </ng-container>

              <!-- String Input -->
              <ng-container *ngIf="getDataType(key, newRow[key]) === 'string'">
                <mat-form-field
                  appearance="outline"
                  class="w-100 dropdown-pd-none"
                >
                  <input
                    matInput
                    [(ngModel)]="newRow[key]"
                    [disabled]="isNonEditable(key)"
                  />
                </mat-form-field>
              </ng-container>

              <!-- Number Input -->
              <ng-container *ngIf="getDataType(key, newRow[key]) === 'number'">
                <mat-form-field
                  appearance="outline"
                  class="w-100 dropdown-pd-none"
                >
                  <input
                    matInput
                    type="number"
                    [(ngModel)]="newRow[key]"
                    [disabled]="isNonEditable(key)"
                  />
                </mat-form-field>
              </ng-container>

              <!-- Boolean Checkbox -->
              <ng-container *ngIf="getDataType(key, newRow[key]) === 'boolean'">
                <mat-checkbox
                  [(ngModel)]="newRow[key]"
                  [disabled]="isNonEditable(key)"
                ></mat-checkbox>
              </ng-container>

              <div class="error-message">{{ getInputError(key) }}</div>
            </td>

            <td class="order-actions">
              <div class="d-flex">
                <button
                  (click)="save(newRow)"
                  mat-stroked-button
                  color="primary"
                  class="icon-center icon-width"
                  matTooltip="{{
                    'ADD_ROLE_APP.TOOLTIP.NEW_RECORD' | translate
                  }}"
                >
                  <mat-icon class="icon-compact">check_circle</mat-icon>
                </button>
                <button
                  (click)="cancel()"
                  mat-stroked-button
                  color="warn"
                  class="icon-center icon-width ms-1"
                  matTooltip="{{ 'ADD_ROLE_APP.TOOLTIP.CANCEL' | translate }}"
                >
                  <mat-icon class="icon-compact">cancel</mat-icon>
                </button>
              </div>
            </td>
          </tr>

          <!-- Existing Rows -->
          <tr *ngFor="let row of dataList" (click)="enableEditMode(row.id)">
            <td *ngFor="let key of activeColumns">
              <!-- EDITING MODE -->
              <ng-container *ngIf="editRowId == row.id">
                <!-- Select Dropdown -->
                <ng-container *ngIf="getDataType(key, row[key]) === 'select'">
                  <mat-form-field
                    appearance="outline"
                    class="w-100 dropdown-pd-none"
                  >
                    <mat-select
                      [(value)]="row[key]"
                      [disabled]="isNonEditable(key)"
                    >
                      <mat-option
                        *ngFor="let option of dropdownOptions[key]"
                        [value]="option?.value || option"
                      >
                        {{ option?.name || option?.title || option }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </ng-container>

                <!-- String Input -->
                <ng-container *ngIf="getDataType(key, row[key]) === 'string'">
                  <mat-form-field
                    appearance="outline"
                    class="w-100 dropdown-pd-none"
                  >
                    <input
                      matInput
                      [(ngModel)]="row[key]"
                      [disabled]="isNonEditable(key)"
                    />
                  </mat-form-field>
                </ng-container>

                <!-- Number Input -->
                <ng-container *ngIf="getDataType(key, row[key]) === 'number'">
                  <mat-form-field
                    appearance="outline"
                    class="w-100 dropdown-pd-none"
                  >
                    <input
                      matInput
                      type="number"
                      [(ngModel)]="row[key]"
                      [disabled]="isNonEditable(key)"
                    />
                  </mat-form-field>
                </ng-container>

                <!-- Boolean Checkbox -->
                <mat-checkbox
                  *ngIf="getDataType(key, row[key]) === 'boolean'"
                  [(ngModel)]="row[key]"
                  [disabled]="isNonEditable(key)"
                ></mat-checkbox>

                <div class="error-message">{{ getInputError(key) }}</div>
              </ng-container>

              <!-- DISPLAY MODE -->
              <ng-container *ngIf="editRowId != row.id">
                <span *ngIf="getDataType(key, row[key]) === 'select'">
                  {{ getDisplayValue(key, row[key]) }}
                </span>
                <span *ngIf="getDataType(key, row[key]) !== 'select'">
                  <span *ngIf="getDataType(key, row[key]) !== 'boolean'">{{
                    row[key]
                  }}</span>
                  <mat-checkbox
                    *ngIf="getDataType(key, row[key]) === 'boolean'"
                    [checked]="row[key]"
                    disabled
                  ></mat-checkbox>
                </span>
              </ng-container>
            </td>

            <td>
              <!-- EDITING MODE ACTIONS -->
              <ng-container *ngIf="editRowId == row.id">
                <div class="d-flex">
                  <button
                    (click)="save(row)"
                    mat-stroked-button
                    color="primary"
                    class="icon-center icon-width"
                    matTooltip="{{ 'ADD_ROLE_APP.TOOLTIP.UPDATE' | translate }}"
                  >
                    <mat-icon class="icon-compact">check_circle</mat-icon>
                  </button>
                  <button
                    (click)="cancel()"
                    mat-stroked-button
                    color="warn"
                    class="icon-center icon-width ms-1"
                    matTooltip="{{ 'ADD_ROLE_APP.TOOLTIP.CANCEL' | translate }}"
                  >
                    <mat-icon class="icon-compact">cancel</mat-icon>
                  </button>
                </div>
              </ng-container>

              <!-- VIEW MODE ACTIONS -->
              <ng-container *ngIf="editRowId != row.id">
                <div class="d-flex">
                  <button
                    *ngIf="canEdit"
                    (click)="enableEditMode(row.id)"
                    mat-stroked-button
                    color="primary"
                    class="icon-center icon-clean icon-width"
                    matTooltip="{{ 'ADD_ROLE_APP.TOOLTIP.EDIT' | translate }}"
                  >
                    <mat-icon class="icon-compact">edit</mat-icon>
                  </button>
                  <button
                    *ngIf="canDelete"
                    (click)="deleteRow(row)"
                    mat-stroked-button
                    color="warn"
                    class="icon-center icon-clean icon-width ms-1"
                    matTooltip="{{ 'ADD_ROLE_APP.TOOLTIP.DELETE' | translate }}"
                  >
                    <mat-icon class="icon-compact">delete</mat-icon>
                  </button>
                </div>
              </ng-container>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
